class Domain {

    constructor(){
        this.bindLoadEvents();
    }

    bindLoadEvents(){
        this.initHeroSlider();
        this.initZoomableSlider();
        this.initHomePageOverlay();
    }

    initZoomableSlider()
    {
        let zoomable_slider = document.getElementById('zoomable-slider');
        if (zoomable_slider) {
            let slider = jQuery('.zoomable-slider').slick({dots: true, infinite: false});
            let zoomable_slider_thumbnails = document.querySelectorAll('.zoomable-slider-thumbnail');

            zoomable_slider_thumbnails.forEach(function(thumbnail, index){
                thumbnail.addEventListener('click', function(){
                    $('.zoomable-slider').slick('slickGoTo', index, true);
                });
            });
        }
    }

    initHeroSlider()
    {
        let hero_slider = document.getElementById('hero-slider');
        if (hero_slider) {
            jQuery(document).ready(function(){
                jQuery('.hero-slider').slick(
                    {
                        dots: true,
                        infinite: true,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 8000
                    }
                );
            });
        }
    }

    initHomePageOverlay()
    {
        /**
         * Get the homepage overlay, if its still being shown after it has gone to zero opacity then remove from
         * the dom.
         */
        jQuery(document).ready(function(){
            let homepage_overlay_image = $('.homepage-overlay-image').first();

            let homepage_overlay_timer = setInterval(function(){
                if( homepage_overlay_image.css("opacity") == 0 ) {
                    clearInterval(homepage_overlay_timer);
                    homepage_overlay_image.remove();
                }
            }, 500);
        });

    }
}

export default Domain;